/* __next_internal_client_entry_do_not_use__ Link,Anchor auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { jsx as _jsx } from "react/jsx-runtime";
import { getLocation } from "@faire/web--source/common/globals/getLocation";
import { appendFaireDirectBrandAliasQueryParam } from "@faire/web--source/common/routes/faire-direct/appendFaireDirectBrandAliasQueryParam";
import { RoutingContext } from "@faire/web--source/ui/routing/RoutingContext";
import { matchLocale, prependLocaleToUrl } from "@faire/web--source/ui/routing/util";
import React from "react";
import { // eslint-disable-next-line @faire-web/no-restricted-imports
Link as ReactLink, useHistory } from "react-router-dom";
/**
 * Thin wrapper around React Links (from react-router-dom).
 * The thin wrapper allows us to globally augment all Faire URLs, if we want to.
 */ export var Link = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var _React_useContext = React.useContext(RoutingContext), faireDirectBrandAlias = _React_useContext.faireDirectBrandAlias, faireDirectBrandToken = _React_useContext.faireDirectBrandToken, _React_useContext_Link = _React_useContext.Link, Link = _React_useContext_Link === void 0 ? ReactLink : _React_useContext_Link, _React_useContext_useRouterOrHistory = _React_useContext.useRouterOrHistory, useRouterOrHistory = _React_useContext_useRouterOrHistory === void 0 ? useHistory : _React_useContext_useRouterOrHistory, routingContext = _object_without_properties(_React_useContext, [
        "faireDirectBrandAlias",
        "faireDirectBrandToken",
        "Link",
        "useRouterOrHistory"
    ]);
    var to = props.to, skipPrependLocale = props.skipPrependLocale, otherProps = _object_without_properties(props, [
        "to",
        "skipPrependLocale"
    ]);
    var history = useRouterOrHistory();
    var shouldAppendFaireDirectQueryParam = faireDirectBrandAlias && faireDirectBrandToken;
    var toStr, augmentedToStr;
    var augmentedTo;
    if ((typeof to === "undefined" ? "undefined" : _type_of(to)) === "object") {
        augmentedTo = to;
        augmentedTo.pathname = prependLocaleToUrl("".concat(to.pathname), routingContext);
        if (shouldAppendFaireDirectQueryParam) {
            var // We need to fall back on an empty string because we want appendFaireDirectBrandAliasQueryParam
            // to return the search, *not* the path.
            _augmentedTo_search;
            augmentedTo.search = appendFaireDirectBrandAliasQueryParam(augmentedTo.pathname, faireDirectBrandAlias, faireDirectBrandToken, (_augmentedTo_search = augmentedTo.search) !== null && _augmentedTo_search !== void 0 ? _augmentedTo_search : "");
        }
        var _to_pathname;
        toStr = (_to_pathname = to.pathname) !== null && _to_pathname !== void 0 ? _to_pathname : "";
        var _augmentedTo_pathname;
        augmentedToStr = (_augmentedTo_pathname = augmentedTo.pathname) !== null && _augmentedTo_pathname !== void 0 ? _augmentedTo_pathname : "";
    } else {
        /**
         * for bots language selectors, we do not want to prependLocale to US links
         * for example, if localized path is /careers, we want to direct bots to /careers, not /en/careers
         */ augmentedTo = skipPrependLocale ? to : prependLocaleToUrl("".concat(to), routingContext);
        if (shouldAppendFaireDirectQueryParam) {
            augmentedTo = appendFaireDirectBrandAliasQueryParam(augmentedTo, faireDirectBrandAlias, faireDirectBrandToken);
        }
        toStr = to;
        augmentedToStr = augmentedTo;
    }
    var linkProps = _object_spread({
        innerRef: ref,
        to: augmentedTo,
        onClick: function() {
            if (!matchLocale(toStr, routingContext === null || routingContext === void 0 ? void 0 : routingContext.locale)) {
                var _getLocation;
                history.push(augmentedToStr);
                (_getLocation = getLocation()) === null || _getLocation === void 0 ? void 0 : _getLocation.reload();
            }
        }
    }, otherProps);
    return /*#__PURE__*/ _jsx(Link, _object_spread({}, linkProps));
});
/**
 * Thin wrapper around `<a>` tags.
 * The thin wrapper allows us to globally augment all Faire URLs, if we want to.
 */ export var Anchor = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var _React_useContext = React.useContext(RoutingContext), faireDirectBrandAlias = _React_useContext.faireDirectBrandAlias, faireDirectBrandToken = _React_useContext.faireDirectBrandToken, routingContext = _object_without_properties(_React_useContext, [
        "faireDirectBrandAlias",
        "faireDirectBrandToken"
    ]);
    var children = props.children, href = props.href, otherProps = _object_without_properties(props, [
        "children",
        "href"
    ]);
    var potentiallyPrependLocaleHref = (href === null || href === void 0 ? void 0 : href.startsWith("/")) ? prependLocaleToUrl(href, routingContext) : href;
    var shouldAppendFaireDirectQueryParam = faireDirectBrandAlias && faireDirectBrandToken && !!potentiallyPrependLocaleHref;
    var augmentedHref = shouldAppendFaireDirectQueryParam ? appendFaireDirectBrandAliasQueryParam(potentiallyPrependLocaleHref !== null && potentiallyPrependLocaleHref !== void 0 ? potentiallyPrependLocaleHref : "", faireDirectBrandAlias, faireDirectBrandToken) : potentiallyPrependLocaleHref;
    return(// eslint-disable-next-line @faire/no-raw-anchor-tag
    /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({
        ref: ref,
        href: augmentedHref
    }, otherProps), {
        children: children
    })));
});
